var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.521,
    height: 27.521,
    viewBox: "0 0 27.521 27.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard",
    d: "M17.265,27.521a1.711,1.711,0,0,1-1.71-1.71V17.265a1.71,1.71,0,0,1,1.71-1.71h8.546a1.711,1.711,0,0,1,1.71,1.71v8.546a1.712,1.712,0,0,1-1.71,1.71Zm-15.556,0A1.711,1.711,0,0,1,0,25.811V17.265a1.71,1.71,0,0,1,1.709-1.71h8.547a1.711,1.711,0,0,1,1.709,1.71v8.546a1.711,1.711,0,0,1-1.709,1.71ZM17.265,11.965a1.711,1.711,0,0,1-1.71-1.709V1.709A1.71,1.71,0,0,1,17.265,0h8.546a1.711,1.711,0,0,1,1.71,1.709v8.547a1.711,1.711,0,0,1-1.71,1.709Zm-15.556,0A1.71,1.71,0,0,1,0,10.256V1.709A1.71,1.71,0,0,1,1.709,0h8.547a1.71,1.71,0,0,1,1.709,1.709v8.547a1.711,1.711,0,0,1-1.709,1.709Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.26e2e912bb9f0d58e6d2a87449cdafd8.svg";
export { ForwardRef as ReactComponent };